export default "/_next/static/fonts/Graphik-SemiboldItalic-b3371d533336c2a3a21124b9ec0dbb8f.woff";